import { useQuery } from '@tanstack/react-query';
import { ApiService } from '../../services/apiService';
import { Presenter } from '../../types/Presenter';
import { cachingStrategyService, DataType } from '../../services/cachingStrategyService';

export const PRESENTERS_QUERY_KEY = ['presenters'] as const;

export const usePresentersQuery = () => {
  // Get optimized caching strategy for presenters data
  const cacheStrategy = cachingStrategyService.getStrategy(DataType.PRESENTERS_DATA);
  
  return useQuery({
    queryKey: PRESENTERS_QUERY_KEY,
    queryFn: async (): Promise<Presenter[]> => {
      const response = await ApiService.getPresenters();
      if (!response.success) {
        throw new Error(response.error || 'Failed to fetch presenters');
      }
      return response.data;
    },
    // Apply centralized caching strategy for presenters data
    staleTime: cacheStrategy.staleTime,
    gcTime: cacheStrategy.gcTime,
    refetchOnWindowFocus: cacheStrategy.refetchOnWindowFocus,
    refetchOnReconnect: cacheStrategy.refetchOnReconnect,
    retry: cacheStrategy.retry,
    retryDelay: cacheStrategy.retryDelay,
  });
};
